/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Irrigation_Schedule_Window_InvalidInputs */

const vi_error_irrigation_schedule_window_invalid = /** @type {(inputs: Error_Irrigation_Schedule_Window_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giờ kết thúc phải sau giờ bắt đầu`)
};

/**

* @param {Error_Irrigation_Schedule_Window_InvalidInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_irrigation_schedule_window_invalid = /** @type {((inputs?: Error_Irrigation_Schedule_Window_InvalidInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Irrigation_Schedule_Window_InvalidInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_irrigation_schedule_window_invalid(inputs)
});